import React from 'react';
import Sidebar from './Sidebar';

/**
 * Dashboard 布局组件
 * 左侧边栏 + 右侧内容区
 */
function DashboardLayout({ children, theme, setTheme }) {
  return (
    <div className="flex min-h-screen bg-[#f0f2f5] dark:bg-gray-900">
      {/* 左侧边栏 */}
      <Sidebar theme={theme} setTheme={setTheme} />

      {/* 右侧主内容区 */}
      <main className="flex-1 overflow-x-hidden">
        {children}
      </main>
    </div>
  );
}

export default DashboardLayout;
